import { render, staticRenderFns } from "./JoinMeeting.vue?vue&type=template&id=2e13782d&scoped=true"
import script from "./JoinMeeting.vue?vue&type=script&lang=js"
export * from "./JoinMeeting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e13782d",
  null
  
)

export default component.exports